import { useState, useEffect } from 'react'
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import CSSBaseLine from '@mui/material/CssBaseline'
import { Container } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import Navbar from './components/NavBar'
import theme from './styles/theme'
import HomeScreen from './screens/home'
import SellScreen from './screens/sellProperty'
import Footer from './components/footer'
import NotFound from './screens/notFound'
import PropertyDetailScreen from './screens/propertyDetail'
import MarketPage from './screens/market'
import ContactScreen from './screens/contact'
import LandscapingScreen from './screens/landscaping'
import AboutScreen from './screens/about'
import RentalsPage from './screens/rentals'
import ScrollToTop from './components/ScrollToTop'
import * as ROUTES from './routes'
import { currencies, CurrencyContext } from './currencyContext'
import { units, LandSizeUnitContext } from './landSizeUnitContext'
import { ContactContext, initialContact } from './contactContext'
import WhatsAppButton from './components/WhatsAppButton'

const PAGE_TITLES = {
  '/':            'Choice Real Estate — Dominica',
  '/home':        'Choice Real Estate — Dominica',
  '/properties':  'Browse Properties — Choice Real Estate',
  '/rentals':     'Rentals — Choice Real Estate',
  '/sell':        'Sell Your Property — Choice Real Estate',
  '/contact':     'Contact Us — Choice Real Estate',
  '/about':       'About Us — Choice Real Estate',
  '/landscaping': 'Landscaping Services — Choice Real Estate',
}

function TitleManager() {
  const location = useLocation()
  useEffect(() => {
    const match = Object.keys(PAGE_TITLES).find(path =>
      path === location.pathname || location.pathname.startsWith(path + '/')
    )
    if (match && !location.pathname.startsWith('/properties/')) {
      document.title = PAGE_TITLES[match]
    }
  }, [location.pathname])
  return null
}

function App() {
  const [currency, setCurrency] = useState(currencies[0])
  const [unit, setUnit]         = useState(units[0])

  return (
    <HelmetProvider>
      <HashRouter>
         <ScrollToTop /> 
        <TitleManager />
        <ThemeProvider theme={theme}>
          <CurrencyContext.Provider value={{ value: currency, changeCurrency: v => setCurrency(v) }}>
            <LandSizeUnitContext.Provider value={{ value: unit, changeUnit: u => setUnit(u) }}>
              <ContactContext.Provider value={{ value: initialContact, changeValue: () => {} }}>
                <CSSBaseLine />
                <Navbar />
                <Container disableGutters maxWidth='xl' component='div' sx={{ minHeight: '100vh' }}>
                  <Routes>
                    <Route path={ROUTES.ROOT}                             element={<HomeScreen />} />
                    <Route path={ROUTES.HOME}                             element={<HomeScreen />} />
                    <Route path={ROUTES.SELL}                             element={<SellScreen />} />
                    <Route path={ROUTES.CONTACT}                          element={<ContactScreen />} />
                    <Route path={ROUTES.PROPERTIES}                       element={<MarketPage />} />
                    <Route path={ROUTES.PROPERTIES + '/:propertyID'}      element={<PropertyDetailScreen />} />
                    <Route path={ROUTES.RENTALS}                          element={<RentalsPage />} />
                    <Route path={ROUTES.LANDSCAPING}                      element={<LandscapingScreen />} />
                    <Route path={ROUTES.ABOUT}                            element={<AboutScreen />} />
                    <Route path='*'                                        element={<NotFound />} />
                  </Routes>
                  <WhatsAppButton phoneNumber="17672259495" />
                </Container>
                <Footer />
              </ContactContext.Provider>
            </LandSizeUnitContext.Provider>
          </CurrencyContext.Provider>
        </ThemeProvider>
      </HashRouter>
    </HelmetProvider>
  )
}

export default App